<div [attr.data-cy]="containerNodeDataCy"
  [class]="globalClass"
  [ngStyle]="entityTreeNodeMaxHeight">

  <!-- Entity name section -->
  <div [ngClass]="{'not-original-order': !isInOriginalPosition}" [attr.data-cy]="containerNameDataCy" class="entity-name">{{entityNode.name}}</div>

  <!-- Entity content section -->
  <div [attr.data-cy]="contentNodeDataCy"
    [ngClass]="{'disable': !enableEntity, 'not-original-order': !isInOriginalPosition}" class="entity-content">

    <!-- Path node and connectors section  -->
    @if (entityUtilService.entityHasPathOrConnections(entityNodeDisplayData)) {
      <div (cdkDropListDropped)="dropInPath($event)" [attr.data-cy]="pathNodeDataCy"
        [cdkDropListConnectedTo]="[connectionsDropZoneId, poolDropZoneId]"
        [cdkDropListData]="[entityNode.path]"
        [id]="pathNodeDropZoneId"
        cdkDropList
        class="entity-node center-content">
        @if (hasAddButton) {
          <div class="add-button">
            <app-tooltip [dynamic]="false" message="Add connections">
              <button (click)="skipEntity(false)"
                [attr.data-cy]="addButtonDataCy"
                class="add-cut-button  iwp-icon-gen_plus">
              </button>
            </app-tooltip>
          </div>
        }
        @if (hasCutButton) {
          <div class="cut-button">
            <app-tooltip [dynamic]="false" message="Cut connections">
              <button (click)="skipEntity(true)"
                [attr.data-cy]="cutButtonDataCy"
              class="add-cut-button iwp-icon-gen_cut"></button>
            </app-tooltip>
          </div>
        }
        <!-- Inner branch path connector -->
        @if (hasPathNodeConnector) {
          <div
            class="path-connector"
            data-cy="entity-tree-path-connector">
            <div [class]="topPathConnectorClass"></div>
            <div [class]="bottomPathConnectorClass"></div>
          </div>
        }
        <!-- Path connector unfinished path marker -->
        @if (hasUnfinishedPathOriginMarker) {
          <div
            [class]="unfinishedPathOriginClass">
            <div [class]="unfinishedPathOriginLineClass(UNFINISHED_PATH_MARKER_BASE_CLASS)"></div>
            <ng-container *ngTemplateOutlet="unfinishedPathMarker"></ng-container>
          </div>
        }
        <!-- Path node to connections connector -->
        <div [class]="finalPathToConnectionsConnectorClass"
          data-cy="entity-tree-path-to-connections-connector">
          <!-- Path to connections unfinished path marker -->
          @if (hasUnfinishedPathOriginConnectionsMarker) {
            <div
              [class]="unfinishedPathOriginConnectionsClass">
              <div [class]="unfinishedPathOriginLineClass(UNFINISHED_PATH_MARKER_BASE_CONNECTIONS_CLASS)"></div>
              <ng-container *ngTemplateOutlet="unfinishedPathMarker"></ng-container>
            </div>
          }
        </div>
        <!-- Path node -->
        @if (entityNodeDisplayData.hasPath) {
                    <ng-container *ngTemplateOutlet="entityNode.path != null ? pathNodeContainer : dropZone;
                        context: { message: dragAndDropMessage(entityNode, EntityElementTypeEnum.PATH), dataCy: 'entity-tree-node-drop-zone-path' }">
          </ng-container>
        }
      </div>
    }

    <!-- Connections section -->
    @if (entityNodeDisplayData.hasConnections) {
      <!-- Connection items section -->
      <!-- TODO: CTWILS-NA : After refactor the polls, paths and connections areas, this line should be added to ngClass
      'closing-connector': hasClosingConnectionsConnector -->
      <div #entityConnectionsContainer
        (cdkDropListDropped)="dropInConnections($event)"
        [attr.data-cy]="connectionsDataCy"
        [cdkDropListConnectedTo]="connectionsDropListConnectedTo()"
        [cdkDropListData]="entityNode.connections"
        [cdkDropListDisabled]="!enableEntity"
        [id]="connectionsDropZoneId"
                 [ngClass]="{
                    'disable': !enableEntity,
                    'center-content': !entityUtilService.hasSelectedConnections(entityNode)
                 }"
        cdkDropList
        class="entity-connections">
        <ng-container
                        *ngTemplateOutlet="entityUtilService.hasSelectedConnections(entityNode) ? connections : dropZone;
                        context: { message: dragAndDropMessage(entityNode, EntityElementTypeEnum.CONNECTION), dataCy: 'entity-tree-node-drop-zone-connections', ngClass: 'unfinishPath' }">
        </ng-container>
      </div>
    }

    <!-- Pool section -->
    <div #entityPoolContainer
      [attr.data-cy]="poolDataCy"
             [ngClass]="{
                 'no-border': !entityUtilService.entityHasPathOrConnections(entityNodeDisplayData),
                 'disable': !enableEntity,
                 'no-connections': !entityNodeDisplayData.hasConnections
             }"
      class="entity-pool-container">

      <!-- Pool items section -->
      <div (cdkDropListDropped)="dropInPool($event)"
        [cdkDropListConnectedTo]="poolDropListConnectedTo()"
        [cdkDropListData]="entityNode.pool"
        [cdkDropListDisabled]="!enableEntity"
        [id]="poolDropZoneId"
        [ngClass]="{'with-view-less': hasViewLess, 'no-border': !entityUtilService.entityHasPathOrConnections(entityNodeDisplayData)}"
        cdkDropList
        class="entity-pool">
        <app-drag-and-drop-grid (addButtonClick)="openAddModal()"
          (reorderedItems)="reorderPool($event)"
          [addButtonLabel]="entityNode.nameLabelText"
          [buttonLabelArticle]="getButtonLabelArticle(entityNode.nameLabelText)"
          [allowReorder]="entityNode.hasManualSorting"
          [dragAndDropGridConnectedTo]="poolDropListConnectedTo()"
          [dragAndDropGridDisabled]="!enableEntity"
          [hasAddButton]="hasPoolAddButton()"
          [itemsTemplate]="poolItemTemplate"
          [items]="getPoolDragAndDropItems()"
        [trackBy]="trackByContextMenuActions"></app-drag-and-drop-grid>
      </div>

      <div class="view-mode-container">
        @if (hasViewMore) {
          <div [ngClass]="{'pool': !entityNodeDisplayData.hasConnections}"
            class="gradient"
          data-cy="view-more-gradient"></div>
        }
        @if (hasViewMore) {
          <div (click)="clickViewMore()"
            class="view-more iwp-icon-gen_arrow_down"
          data-cy="view-more-button"></div>
        }
        @if (hasViewLess) {
          <div (click)="clickViewLess()"
            class="view-less iwp-icon-gen_arrow_up"
            data-cy="view-less-button"
          ></div>
        }
      </div>
    </div>
  </div>

</div>


<!-- Path node container template -->
<ng-template #pathNodeContainer>
  @if (entityNode.path != null) {
    <div
      [cdkDropListConnectedTo]="pathDropListConnectedTo()"
      cdkDropList
      class="entity-path-node-container"
      data-cy="entity-tree-node-path-element">
      <app-entity-element (removeAction)="removeFromPath($event)"
        [attr.data-cy]="getDragItemDataCy(entityNode.path, EntityElementTypeEnum.PATH)"
        [cdkDragData]="getEntityElementDropEventObject(entityNode.path, EntityElementTypeEnum.PATH)"
        [displayMode]="displayMode"
        [element]="entityNode.path"
        [entityElementType]="EntityElementTypeEnum.PATH"
        [showParentCode]="true"
        cdkDrag
      isSelected="true"></app-entity-element>
    </div>
  } @else {
    @if (enableEntity) {
      <div [attr.data-cy]="dataCy" class="drop-zone-container">
        <div [class]="dropzoneClass" data-cy="drop-zone">
          <p [class]="dropZoneMessageClass" [innerHTML]="message" data-cy="entity-tree-node-drop-zone-message"></p>
        </div>
      </div>
    }
  }
</ng-template>

<!-- Connections container template -->
<ng-template #connections>
  @for (element of entityNode.connections; track element) {
    <div
      [cdkDropListConnectedTo]="connectionsDropListConnectedTo()"
      cdkDropList
      class="entity-connections-element">
      <app-entity-element (click)="addEntityToPath(element)"
        (removeAction)="removeFromConnections($event)"
        [attr.data-cy]="getDragItemDataCy(element, EntityElementTypeEnum.CONNECTION)"
        [cdkDragData]="getEntityElementDropEventObject(element, EntityElementTypeEnum.CONNECTION)"
        [cdkDragDisabled]="disableDragForConnectionItem()"
        [displayMode]="displayMode"
        [element]="element"
        [entityElementType]="EntityElementTypeEnum.CONNECTION"
        [showParentCode]="true"
        [warnings]="getInactiveElementWarnings(element)"
      cdkDrag></app-entity-element>
    </div>
  }
</ng-template>

<!-- Dropzone container template -->

<ng-template #unfinishedPathMarker>
  <app-tooltip [dynamic]="false" message="Unfinished path origin">
    <span [attr.data-cy]="markerType.UNFINISHED_PATH_MARKER_CLASS"
    [class]="markerType.UNFINISHED_PATH_MARKER_CLASS"></span>
  </app-tooltip>
</ng-template>

<!-- Pool item template -->
<ng-template #poolItemTemplate let-item="item">
  <app-entity-element (contextMenuAction)="contextMenuClick($event)"
    (mousedown)="closeContextMenus()"
    [attr.data-cy]="getDragItemDataCy(item.value, EntityElementTypeEnum.POOL)"
    [contextMenuType]="poolContextMenuType"
    [displayMode]="displayMode"
    [element]="item.value"
    [entityElementType]="EntityElementTypeEnum.POOL"
    [showParentCode]="true"
  class="pool-item"></app-entity-element>
</ng-template>
